import { useRef, useState } from 'react';
import { useRouter } from 'next/router';
import moment from 'moment/moment';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import getIp from '../../api/getIp.js';

import getPreventivo from '../../api/getPreventivo';
import { getEstimatorQueriesCacheByIds } from '../../api/estimator/estimatorsQueriesCache';
import getBanche from '../../api/getBanche';
import { getBankImage } from '../../utilities/banks';
import useStorage from '../../hooks/useStorage';
import { createEstimatorQuery } from '../../api/estimator/createEstimatorQuery';
import addUserRequest from '../../api/request/addUserRequest';
import { updateAnswers } from '../../api/request/updateAnswers';
import { track } from '../../utilities/trackerStatistics';


import { useStore } from '../../store/useStore';
import { useShallow } from 'zustand/react/shallow';

const prepareResultsQuotation = (preventivi, banks, duration) => {
  // TODO: controllare lo slice (al momento abbiamo visto che con 10 preventivi regge)
  // FIX TEMPORANEA
  return Object.keys(preventivi).slice(0,10).reduce((acc, key) => {
     acc.push({ ...preventivi[key][0], durata: duration, bankImage: getBankImage(banks, preventivi[key][0]?.nomebanca) }); // Aggiungi il primo elemento di ciascun array alla lista
    return acc;
  }, []);
};

export const renderResultsQuotationServerSide = async props => {
  try {
    const { preventivoId } = props;
    const preventiviIdsArr = preventivoId.split(',');

    // Ottieni i dati dalla cache delle query dell'estimatore usando gli ID
    const responseQueriesCache = await getEstimatorQueriesCacheByIds(preventiviIdsArr);
    const { data: queriesCacheData } = responseQueriesCache;

    // Verifica se sono presenti dati nel primo elemento dei risultati
    if (queriesCacheData.length > 0 && queriesCacheData[0]?.queryResult?.preventivi) {
      const preventivi = queriesCacheData[0]?.queryResult?.preventivi;
      const queryBody = queriesCacheData[0]?.queryBody;

      const responseBanks = await getBanche();

      const quotationResults = prepareResultsQuotation(preventivi, responseBanks?.banche, queryBody?.durata);

      const propsToSend = { defaultQuotationResults: quotationResults, defaultEstimatorData: queryBody, banks: responseBanks?.banche };

      // props are passed in children ti prevent parsing error from html-react-parser
      return `<ResultsQuotation>${JSON.stringify(propsToSend)}</ResultsQuotation>`;
    } else {
      // Nessun risultato disponibile
      // console.log('Nessun risultato disponibile.');
      return [];
    }
  } catch (error) {
    // Gestisci gli errori
    console.error('Si è verificato un errore:', error);
    return [];
  }
};

const defaultFinalita = [
  {
    value: 'Acquistoprimacasa',
    label: 'Acquisto prima casa',
  },
  {
    value: 'Acquistosecondacasa',
    label: 'Acquisto seconda casa',
  },
  {
    value: 'Acquisto+Sostituzione',
    label: 'Acquisto + liquidità',
  },
  {
    value: 'Acquisto+Ristrutturazione',
    label: 'Acquisto + ristrutturazione',
  },
  {
    value: 'Surroga',
    label: 'Surroga',
  },
];

/* const estimatorData = {
   // finalita: 'Acquisto prima casa',
   // tipoTasso: 'fisso',
   // importo: '140000',
   // valoreImmobile: '200000',
   // durata: '25',
    //eta: '34',
  //  nomebanca: 'Tutte',
    tipologiaLavoro: 'permanent_contract',
    citta: 'Chieti',
    user: {
      name: '-',
      lastName: '-',
      email: '',
      phone: '',
      prefix: '+39',
    },
    reqid: '',
  };*/

const useResultsQuotation = ({ banks, defaultQuotationResults, defaultEstimatorData }) => {
  const { getItem, getItems, setItem } = useStorage();
  const router = useRouter();

  const [isLoading, setIsLoading] = useState(false);
  const [quotationResults, setQuotationResults] = useState(defaultQuotationResults);
  const currentEstimatorData = useRef(defaultEstimatorData);
  const {
    userRequestId,
    leadId,
    valoreCasa,
    importoMutuo,
    eta,
    tasso,
    durata,
    finalita,
    ricerca,
    comune,
    regione,
    provincia,
    idoneita,
    consulenza,
    fattibilita,
    intestatari,
    reddito,
    redditoOpen,
    provenienza,
    contratto,
    product,
    user,
    setLeadId,
    setProduct,
    cap,
    setValoreCasa,
    setImportoMutuo,
    setEta,
    setTasso,
    setDurata,
    setFinalita,
    setUserRequestId,
  } = useStore(
    useShallow(state => ({
      userRequestId: state.userRequestId,
      leadId: state.leadId,
      valoreCasa: state.valoreCasa,
      importoMutuo: state.importoMutuo,
      eta: state.eta,
      tasso: state.tasso,
      durata: state.durata,
      finalita: state.finalita,
      ricerca: state.ricerca,
      comune: state.comune,
      regione: state.regione,
      provincia: state.provincia,
      cap: state.cap,
      idoneita: state.idoneita,
      consulenza: state.consulenza,
      fattibilita: state.fattibilita,
      intestatari: state.intestatari,
      reddito: state.reddito,
      redditoOpen: state.redditoOpen,
      contratto: state.contratto,
      user: state.user,
      product: state.product,
      provenienza: state.provenienza,
      setLeadId: state.setLeadId,
      setProduct: state.setProduct,
      setValoreCasa: state.setValoreCasa,
      setImportoMutuo: state.setImportoMutuo,
      setEta: state.setEta,
      setTasso: state.setTasso,
      setDurata: state.setDurata,
      setFinalita: state.setFinalita,
      setUserRequestId: state.setUserRequestId,
    })),
  );

  const calculatePayment = async data => {
    currentEstimatorData.current = data;
    const {
      //tipologiaLavoro = '',
      finalita = '',
      tipoTasso = '',
      //citta = '',
      importo = '',
      valoreImmobile = '',
      durata = '',
      eta = '',
    } = data;

    const resp = await getPreventivo({
      importo: importo.replaceAll('.', ''),
      valoreImmobile: valoreImmobile.replaceAll('.', ''),
      tipoTasso,
      finalita,
      durata,
      ordina: 'PerRata',
      eta,
    });

    if (resp.preventivi) {
      const preventiviKeys = Object.keys(resp.preventivi);
      if (preventiviKeys.length > 0) {
        setQuotationResults(prepareResultsQuotation(resp.preventivi, banks, durata));
      }
    }
  };

  const sendDataHandler = async (data, sendQuery = true) => {
    try {
      setIsLoading(true);
      await calculatePayment(data);
      if (sendQuery) {
        await createEstimatorQuery({
          typeOfWork: data.tipologiaLavoro,
          mutualReason: data.finalita,
          taegOrder: data.tipoTasso,
          durationYears: data.durata,
          age: data.eta,
          italianCity: data?.citta || 'N/A',
          mortgageAmount: data.importo.replaceAll('.', ''),
          realEstateValue: data.valoreImmobile.replaceAll('.', ''),
          fromSource: 'cmsModule',
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const onProductClick = async productData => {
    const cookies = await Cookies.get();
    const useragent = window.navigator.userAgent;
    const ip = await getIp();

    const info = { cookies, useragent, ip };

    // console.log('cookies --->', cookies);
    // console.log('useragent --->', useragent);
    // console.log('userip --->', ip);

    const estimatorData = currentEstimatorData.current;

    setItem('estimatorData', JSON.stringify(estimatorData), 'local');

    // setItem('product_banca', productData.nomebanca, 'local');
    // setItem('product_rata', productData.rata, 'local');
    // setItem('product_tan', productData.tan, 'local');
    // setItem('product_type', productData.tipotasso.toLowerCase(), 'local');

    setProduct({
      banca: productData.nomebanca,
      tan: productData.tan,
      rata: productData.rata,
      type: productData.tipotasso.toLowerCase(),
      prodottoId: productData.prodottoId || '0',
    });

    setValoreCasa(estimatorData?.valoreImmobile);
    setImportoMutuo(estimatorData?.importo);
    setEta(estimatorData?.eta);
    setTasso(estimatorData?.tipoTasso);
    setDurata(estimatorData?.durata);
    setFinalita(defaultFinalita?.find(f => f.value === estimatorData?.finalita)?.label);

    // setItem('step_1', estimatorData?.valoreImmobile, 'local'); //valImmobile REPLACED STEPS HERE TOO!
    // setItem('step_0', estimatorData?.importo, 'local'); //importo
    // setItem('step_2', estimatorData?.eta, 'local'); //eta
    // setItem('step_3', estimatorData?.tipoTasso, 'local'); //tipoTasso
    // setItem('step_4', estimatorData?.durata, 'local'); //durata
    // la finalità va passata come label e non come valore
    // setItem('step_5', defaultFinalita?.find(f => f.value === estimatorData?.finalita)?.label, 'local'); //finalita
    // NO setItem('step_6', defaultFinalita?.find(f => f.value === estimatorData?.finalita)?.label, 'local'); // A che punto sei nella ricerca dell’immobile? (Mi sto guardando intorno, ecc..)
    // step_7_regione
    // step_7_provincia
    // step_7 (citta)
    // NO step_8 (ti interessa approfondire SI/NO)
    setItem('selectedElement', JSON.stringify(productData), 'local');

    router.push(`/cerca-mutuo/fattibilita_intro`);

    // se non ho info sul current row è una nuova richiesta
    let currentRow = getItem('currentRow', 'local');
    if (!currentRow) {
      try {
        //inizializzo il gsheet
        const respAns = await updateAnswers({
          answers: [
            getItem(`step_0`, 'local'),
            getItem(`step_1`, 'local'),
            getItem(`step_2`, 'local'),
            getItem(`step_3`, 'local'),
            getItem(`step_4`, 'local'),
            getItem(`step_5`, 'local'),
            getItem(`step_6`, 'local') || 'N/A',
          ],
          time: moment(),
        });
        currentRow = respAns.row;
        // salvo la row del gsheet relativo al flusso
        setItem('currentRow', currentRow, 'local');
      } catch (err) {
        // console.log('error while updating answer', err);
      }
    }

    if (!userRequestId) {
      const newRequestBody = {
        id: userRequestId,
        type: 'mortgage',
        name: user?.name || '-',
        lastName: user?.lastname || '-',
        email: user?.email || '',
        phone: user.phone || '',
        prefix: user.prefix || '+39',
        date: new Date(),
        toc: true,
        tocwa: true,
        message: '',
        // get product from "verifica fattibilità open"
        product: {
          nomebanca: product.banca,
          rata: product.rata,
          prodottoId: product.prodottoId,
        },
        estimatorData: {
          requestId: userRequestId,
          tipologiaLavoro: '',
          finalita: finalita || '',
          tipoTasso: tasso || '',
          durata: durata || '',
          eta: eta || '',
          citta: comune || '',
          importo: (importoMutuo || '').replaceAll('.', ''),
          valoreImmobile: (valoreCasa || '').replaceAll('.', ''),
          fromSource: 'preventivatore',
          search_status: (ricerca || '').replaceAll('.', ''),
          user: {
            name: user.name || '-',
            lastName: user.lastname || '-',
            email: user.email || '',
            phone: user.phone || '',
            prefix: user.prefix || '+39',
          },
          answerRow: null, //current row to take from userRequet
          intestatari: intestatari || null,
          redditi: (intestatari > 1 ? reddito : redditoOpen) || null,
          provenienza_redditi: provenienza || null,
        },
        comune,
        regione,
        provincia,
        cap,
        answerRow: null, //current row to take from userRequet
        info,
      };

      try {
        const resp = await addUserRequest(newRequestBody);

        // MIXPANEL nuovo flusso
        // mixpanel.track('inizio flusso', {
        //   user_req_id: resp.id,
        //   from: getItem('landedIn', 'local'),
        //   fromPage: getItem('landingFrom', 'local'),
        // });
        track('inizio flusso', {
          user_req_id: resp.id,
          from: getItem('landedIn', 'local'),
          fromPage: getItem('landingFrom', 'local'),
        });

        let val = getItem(`step_0`, 'local');
        val = Number(val.replaceAll('.', ''));
        if (val >= 250000) {
          val = 'Alto';
        } else if (val < 250000 && val >= 150000) {
          val = 'Medio';
        } else {
          val = 'Basso';
        }

        // mixpanel.track('1 - importo mutuo', {
        //   answer: val,
        //   current_step: 0,
        //   user_req_id: resp.id,
        // });
        // track('1 - importo mutuo', {
        //   answer: val,
        //   current_step: 0,
        //   user_req_id: resp.id,
        // });

        setUserRequestId(resp.id);
      } catch (err) {
        console.log('error addRequest', err);
      }
    }
  };;

  return { sendDataHandler, defaultFinalita, isLoading, quotationResults, onProductClick };
};

export default useResultsQuotation;
